module.exports = __webpack_public_path__ + "img/success.8b07dd32.png";